module.exports = __webpack_public_path__ + "static/media/1016825.56e5cda3.png";